import React from "react";
import { MainModal } from "../../../../components/modal/MainModal";
import { api } from "../api";
import useUploadXlsx from "../../../../hooks/useUploadXlsx";

export const UploadReferrals = ({ onClose }) => {
  const { error, file, onFileUpload, request } = useUploadXlsx(api.importReferralCategories);

  const primaryBtnHandler = () => {
    request();
    onClose();
  };

  return (
    <>
      <MainModal
        isOpen
        onClose={onClose}
        parentSelector=".referral-categories"
        primaryButtonText="Upload"
        primaryBtnHandler={primaryBtnHandler}
        primaryButtonDisabled={!file}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={onClose}
        width={650}
        height="auto"
        headerCloseHandler={onClose}
        headerText="Import Referral Categories"
      >
        <input type="file" accept=".xlsx" placeholder="Choose XLSX file" onChange={onFileUpload} />

        {error && <div className="help-block">* {error}</div>}
      </MainModal>
    </>
  );
};
